export default __webpack_public_path__ + "static/media/grid-large2.f0332442.svg";